var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyBell(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.822v-2h2v-7c0-1.383.417-2.612 1.25-3.687.833-1.075 1.917-1.78 3.25-2.113v-.7c0-.416.146-.77.438-1.062A1.447 1.447 0 018 .822c.417 0 .77.146 1.063.438.291.291.437.646.437 1.062v.7c1.333.334 2.417 1.038 3.25 2.113C13.583 6.21 14 7.439 14 8.822v7h2v2H0zm8 3c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 016 18.822h4c0 .55-.196 1.021-.588 1.413A1.926 1.926 0 018 20.822z",
    fill: "#1C1C1C"
  })));
}
export default SvgNotifyBell;